<xux-form-panel
  [title]="gridTitleObs | async"
  [description]="descriptionObs$ | async"
  [panelId]="widgetData?.groupId"
  [ngClass]="field.class"
  [class.panel-header-padding]="!field?.description"
>
  <xvi-toolbar panel-heading-content [buttons]="headerButtons" [click]="handleHeaderButtonClick"> </xvi-toolbar>
  <xux-grid-custom
    panel-body-content
    class="xux-list"
    [columns]="gridColumns"
    [items]="initXuxGridItems"
    [view]="gridView"
    [options]="gridOptions"
    [userGridOptions]="userGridOptions"
    [showLoader]="widgetLoader$ | async"
    [buttons]="gridButtons"
    [rowButtons]="rowButtons"
    [userComponents]="dmCustomGridComponents"
    [pinnedTopRowData]="pinnedTopRowData"
    [artificialInputCheckForSearchPanel]="widgetData?.artificialInputCheckForSearchPanel"
    (action)="onGridAction($event)"
    [i18n]="staticI18nTextContent.xuxGrid"
  >
  </xux-grid-custom>

    <xvi-error-block
    panel-body-content
    *ngIf="!widgetData.hiddenErrorBlock"
    [control]="field?.control"
    [showPristineErrors]="showPristineErrors"
  ></xvi-error-block>
</xux-form-panel>
